import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import TalentSearchPage from "@/pages/admin/TalentSearchPage";

export const Route = createFileRoute("/_admin/admin/talent-search")({
  head: () => pageHead("Admin · Talent Search", "AKIVA admin · talent search portal.", "/admin/talent-search", true),
  component: TalentSearchPage,
});
